import React, { Component } from 'react';

class IngredientsView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      editingId: null,
      editForm: {},
      showAddForm: false,
      addForm: { name: '', price: '', vol: '' },
      addError: '',
      filter: '',
    };
    this.addIngredient = this.addIngredient.bind(this);
    this.saveEdit = this.saveEdit.bind(this);
  }

  addIngredient() {
    const { addForm } = this.state;
    const { items } = this.props;
    const name = addForm.name.trim();
    const price = parseFloat(addForm.price);
    const vol = parseFloat(addForm.vol);

    if (!name) return this.setState({ addError: 'Name is required.' });
    if (items.some(i => i.name.toLowerCase() === name.toLowerCase()))
      return this.setState({ addError: 'An ingredient with this name already exists.' });
    if (!addForm.price || isNaN(price) || price <= 0)
      return this.setState({ addError: 'Enter a valid price.' });
    if (!addForm.vol || isNaN(vol) || vol <= 0)
      return this.setState({ addError: 'Enter a valid package weight.' });

    this.props.onAdd({ id: Date.now(), name, price: String(price), vol: String(vol), unit: 'grams' });
    this.setState({ showAddForm: false, addForm: { name: '', price: '', vol: '' }, addError: '' });
  }

  saveEdit() {
    const { editForm } = this.state;
    const name = editForm.name.trim();
    const price = parseFloat(editForm.price);
    const vol = parseFloat(editForm.vol);
    if (!name || isNaN(price) || price <= 0 || isNaN(vol) || vol <= 0) return;
    this.props.onUpdate({ ...editForm, name, price: String(price), vol: String(vol) });
    this.setState({ editingId: null, editForm: {} });
  }

  render() {
    const { items, onDelete, onReset } = this.props;
    const { editingId, editForm, showAddForm, addForm, addError, filter } = this.state;

    const filtered = items.filter(i => i.name.toLowerCase().includes(filter.toLowerCase()));

    return (
      <main className="main-container">
        <div className="page-title">
          <h1>Ingredients & Prices</h1>
          <p>{items.length} ingredients</p>
        </div>

        {/* Add form */}
        {showAddForm ? (
          <div className="card add-form-card">
            <h2 className="card-title">Add New Ingredient</h2>
            <div className="add-form-grid">
              <div>
                <label className="field-label">Name</label>
                <input
                  className="input-field"
                  type="text"
                  placeholder="e.g. cream cheese"
                  value={addForm.name}
                  onChange={e => this.setState({ addForm: { ...addForm, name: e.target.value }, addError: '' })}
                />
              </div>
              <div>
                <label className="field-label">Package price (&#8377;)</label>
                <input
                  className="input-field"
                  type="number"
                  placeholder="e.g. 320"
                  value={addForm.price}
                  onChange={e => this.setState({ addForm: { ...addForm, price: e.target.value }, addError: '' })}
                />
              </div>
              <div>
                <label className="field-label">Package weight (g)</label>
                <input
                  className="input-field"
                  type="number"
                  placeholder="e.g. 1000"
                  value={addForm.vol}
                  onChange={e => this.setState({ addForm: { ...addForm, vol: e.target.value }, addError: '' })}
                />
              </div>
            </div>
            {addError && <p className="form-error">{addError}</p>}
            <div className="add-form-actions">
              <button className="btn btn-primary" onClick={this.addIngredient}>Add Ingredient</button>
              <button
                className="btn btn-ghost"
                onClick={() => this.setState({ showAddForm: false, addForm: { name: '', price: '', vol: '' }, addError: '' })}
              >
                Cancel
              </button>
            </div>
          </div>
        ) : (
          <button className="btn btn-primary add-ingredient-btn" onClick={() => this.setState({ showAddForm: true })}>
            + Add Ingredient
          </button>
        )}

        {/* Search */}
        <div className="ing-search-wrap">
          <input
            className="input-field ing-search"
            type="text"
            placeholder="Search ingredients..."
            value={filter}
            onChange={e => this.setState({ filter: e.target.value })}
          />
        </div>

        {/* Table */}
        <div className="card" style={{ padding: 0 }}>
          <div className="table-wrap" style={{ border: 'none', borderRadius: 'inherit' }}>
            <table className="data-table">
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Price</th>
                  <th>Package</th>
                  <th>Per 100g</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {filtered.length === 0 && (
                  <tr><td colSpan="5" className="empty-row">No ingredients found.</td></tr>
                )}
                {filtered.map(item =>
                  editingId === item.id ? (
                    <tr key={item.id} className="edit-row">
                      <td>
                        <input className="inline-input" type="text" value={editForm.name}
                          onChange={e => this.setState({ editForm: { ...editForm, name: e.target.value } })} />
                      </td>
                      <td>
                        <input className="inline-input" type="number" value={editForm.price}
                          onChange={e => this.setState({ editForm: { ...editForm, price: e.target.value } })} />
                      </td>
                      <td>
                        <input className="inline-input" type="number" value={editForm.vol}
                          onChange={e => this.setState({ editForm: { ...editForm, vol: e.target.value } })} />
                      </td>
                      <td className="muted">—</td>
                      <td>
                        <div className="row-actions">
                          <button className="action-btn save-btn" onClick={this.saveEdit}>Save</button>
                          <button className="action-btn cancel-btn" onClick={() => this.setState({ editingId: null })}>Cancel</button>
                        </div>
                      </td>
                    </tr>
                  ) : (
                    <tr key={item.id}>
                      <td className="ing-name">{item.name}</td>
                      <td>&#8377;{item.price}</td>
                      <td>{item.vol}g</td>
                      <td className="muted">&#8377;{((item.price / item.vol) * 100).toFixed(2)}</td>
                      <td>
                        <div className="row-actions">
                          <button className="action-btn edit-btn"
                            onClick={() => this.setState({ editingId: item.id, editForm: { ...item } })}>
                            Edit
                          </button>
                          <button className="action-btn delete-btn" onClick={() => onDelete(item.id)}>
                            Delete
                          </button>
                        </div>
                      </td>
                    </tr>
                  )
                )}
              </tbody>
            </table>
          </div>
        </div>

        <button className="reset-link" onClick={onReset}>Reset to defaults</button>
      </main>
    );
  }
}

export default IngredientsView;
